export default __webpack_public_path__ + "static/media/flag_uk.4839cec4.svg";